import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "template-actions",
  class: "uk-flex uk-flex-between uk-padding-small"
}
const _hoisted_2 = { class: "left-side-actions uk-flex uk-flex-middle" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { "uk-icon": "icon: plus; ratio: 0.8" }, null, -1)
const _hoisted_4 = { class: "right-side-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_action_button = _resolveComponent("action-button")!
  const _component_item_tree_switcher = _resolveComponent("item-tree-switcher")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_action_button, {
        "main-button": "",
        class: "uk-margin-small-right",
        allowed: _ctx.canWrite,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('createNewTemplate')))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('index_templates.template_actions.new_template')), 1)
        ]),
        _: 1
      }, 8, ["allowed"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_item_tree_switcher, {
        value: _ctx.treeView,
        onSwitcherToggled: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('itemTreeSwitcherToggled')))
      }, null, 8, ["value"])
    ])
  ]))
}